export default __webpack_public_path__ + "static/media/al.b34d9df2.svg";